module.exports = __webpack_public_path__ + "static/media/praxis.268b9fa5.jpg";